import { GetStaticPropsContext } from "next"
import { NextSeo } from "next-seo"
import ErrorPage from "next/error"
import DefaultErrorPage from "next/error"
import { useRouter } from "next/router"
import Feature from "../../components/feature"
import { getAllPagesWithSlug, getSinglePage } from "../../util/contentful-api"

export interface FeatureProps {
  page: any
  preview: boolean
}

// export default function Post({ post, morePosts, preview }) {
const FeaturePage = (props: FeatureProps) => {
  const { page } = props

  const router = useRouter()

  if (!router.isFallback && !page) {
    return <ErrorPage statusCode={404} />
  }

  if (!page) {
    return <DefaultErrorPage statusCode={404} />
  }

  const pageTitle = page.title
  const pageSummary = page.summary

  return (
    <>
      <NextSeo title={pageTitle} description={pageSummary} />
      <main className="page-content">
        <Feature {...props} />
      </main>
    </>
  )
}

export async function getStaticPaths() {
  const allPages = await getAllPagesWithSlug()
  return {
    paths: allPages?.map((slug: string) => `/features/${slug}`) ?? [],
    fallback: true,
  }
}

// export async function getStaticProps(context: GetStaticPropsContext) {
export async function getStaticProps(context: GetStaticPropsContext) {
  const preview = context.preview === true
  const slug = context.params && context.params.slug ? context.params.slug : ""
  const data = await getSinglePage(slug, preview)

  return {
    props: {
      preview,
      page: data ?? null,
    },
  }
}

export default FeaturePage
